import { Form, FormCancel } from "../components";
import { useFeedback } from "../hooks/useFeedback";
import PropTypes from "prop-types";
import { Toast, PageTitle, EmptyState, Card, FormSection, Btn, ConfirmModal, Input, Modal, Select, Spinner } from "../components";
import { useState, useEffect } from "react";
import { apiFetch } from "../api";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { recordFormErrors } from "../observability";

export default function VeiculosPage({ veiculos, setVeiculos, userRole }) {
  const isCompact = useMediaQuery("(max-width: 1023px)");
  const [modal, setModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [form, setForm] = useState({ veiculo: "", placa: "", capacidade: "15", cliente_id: "" });
  const [submitError, setSubmitError] = useState("");
  const { toast, toastType, showToast, showError, dismissToast } = useFeedback("veiculos");
  const [confirmId, setConfirmId] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const isSuperadmin = userRole === "superadmin";

  useEffect(() => {
    if (!isSuperadmin) return;
    apiFetch("/clientes-rotaflex").then(setClientes).catch(() => { });
  }, [isSuperadmin]);

  const openNew = () => {
    setSubmitError("");
    const f = { veiculo: "", placa: "", capacidade: "15", cliente_id: "" };
    setForm(f); setEditItem(null); setFormErrors({}); setModal(true);
  };

  const openEdit = (v) => {
    setSubmitError("");
    const f = { ...v, capacidade: String(Number(v.capacidade) || 15), cliente_id: v.cliente_id || "" };
    setForm(f); setEditItem(v.id); setFormErrors({}); setModal(true);
  };





  const save = async () => {
    if (loading) return;
    setSubmitError("");
    const errors = {};
    if (!form.veiculo.trim()) errors.veiculo = "Nome do veículo é obrigatório.";
    const capacidade = Number(form.capacidade);
    if (!String(form.capacidade).trim() || !Number.isInteger(capacidade) || capacidade < 1 || capacidade > 100) errors.capacidade = "Informe um número inteiro de 1 a 100 passageiros.";
    if (isSuperadmin && !form.cliente_id) errors.cliente_id = "Selecione o cliente.";
    if (Object.keys(errors).length) {
      recordFormErrors(errors, "veiculos");
      setFormErrors(errors);
      return;
    }
    setFormErrors({});
    setLoading(true);
    try {
      const body = { ...form, capacidade };
      if (editItem) {
        const res = await apiFetch(`/veiculos/${editItem}`, { method: "PUT", body: JSON.stringify(body) });
        setVeiculos(veiculos.map(v => v.id === editItem ? res : v));
      } else {
        const res = await apiFetch("/veiculos", { method: "POST", body: JSON.stringify(body) });
        setVeiculos([...veiculos, res]);
      }
      setModal(false);
      showToast(editItem ? "Veículo atualizado." : "Veículo cadastrado.");
    } catch (e) { setSubmitError(e.message); showError(e.message); }
    finally { setLoading(false); }
  };

  const remove = async () => {
    try {
      await apiFetch(`/veiculos/${confirmId}`, { method: "DELETE" });
      setVeiculos(veiculos.filter(v => v.id !== confirmId));
      setConfirmId(null);
      showToast("Veículo excluído.");
    } catch (e) { showError(e.message); }
  };

  return (
    <div className="fade-in">

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12, marginBottom: 24 }}>
        <div>
          <PageTitle icon="fleet">Veículos</PageTitle>
          <p style={{ color: "var(--muted)", fontSize: '1rem', marginTop: 2 }}>{veiculos.length} veículo{veiculos.length === 1 ? "" : "s"} cadastrado{veiculos.length === 1 ? "" : "s"}</p>
        </div>
        <Btn onClick={openNew}>+ Novo veículo</Btn>
      </div>

      {!isCompact && veiculos.length > 0 ? (
        <Card style={{ padding: 0, overflow: 'hidden' }}>
          <table className="rf-data-table">
            <thead><tr><th scope="col">Veículo</th><th scope="col">Placa</th><th scope="col">Capacidade</th><th scope="col" style={{ textAlign: 'right' }}>Ações</th></tr></thead>
            <tbody>{[...veiculos].sort((a,b) => a.veiculo.localeCompare(b.veiculo, 'pt-BR')).map(v => <tr key={v.id}>
              <td><strong>{v.veiculo}</strong></td><td>{v.placa || 'Não informada'}</td><td>{v.capacidade || 15} passageiros</td>
              <td><div className="rf-row-actions"><Btn size="sm" variant="secondary" onClick={() => openEdit(v)}>Editar</Btn><Btn size="sm" variant="danger" onClick={() => setConfirmId(v.id)}>Excluir</Btn></div></td>
            </tr>)}</tbody>
          </table>
        </Card>
      ) : (
      <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 14 }}>
        {veiculos.length === 0 && (
          <Card style={{ gridColumn: "1/-1", textAlign: "center", padding: 40 }}>
            <EmptyState title="Nenhum veículo cadastrado ainda" icon="fleet"><p>Cadastre a identificação e a capacidade dos veículos usados na operação.</p></EmptyState>
            <Btn size="sm" onClick={openNew}>+ Cadastrar veículo</Btn>
          </Card>
        )}
        {[...veiculos].sort((a, b) => a.veiculo.localeCompare(b.veiculo, "pt-BR")).map(v => (
          <Card key={v.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0, overflowWrap: "anywhere" }}>
              <div>
                <div style={{ fontWeight: 600 }}>{v.veiculo}</div>
                <div style={{ fontSize: '0.875rem', color: "var(--muted)", fontVariantNumeric: "tabular-nums", marginTop: 2 }}>{v.placa}</div>
                <div style={{ fontSize: '0.8125rem', color: "var(--muted)", marginTop: 2 }}>Capacidade: {v.capacidade || 15}</div>
              </div>
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <Btn size="sm" variant="secondary" onClick={() => openEdit(v)}>Editar</Btn>
              <Btn size="sm" variant="danger" onClick={() => setConfirmId(v.id)}>Excluir</Btn>
            </div>
          </Card>
        ))}
      </div>
      )}

      {modal && (
        <Modal
          title={editItem ? "Editar veículo" : "Novo veículo"}
          onClose={() => !loading && setModal(false)}
        >
          <Form values={form} onSubmit={save} busy={loading} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <p style={{ color: "var(--muted)", fontSize: '0.875rem' }}>Campos com * são obrigatórios.</p>
            <FormSection title="Identificação">
            <Input
              label="Veículo *"
              value={form.veiculo}
              onChange={e => { setForm({ ...form, veiculo: e.target.value }); if (formErrors.veiculo) setFormErrors(p => ({ ...p, veiculo: "" })); }}
              placeholder="Van / Carro"
              error={formErrors.veiculo}
            />
            {isSuperadmin && (
              <Select
                label="Cliente *"
                value={form.cliente_id}
                onChange={e => { setForm({ ...form, cliente_id: e.target.value }); if (formErrors.cliente_id) setFormErrors(p => ({ ...p, cliente_id: "" })); }}
                error={formErrors.cliente_id}
              >
                <option value="">Selecione o cliente</option>
                {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
              </Select>
            )}
            </FormSection>
            <FormSection title="Dados para a operação">
            <Input label="Placa" value={form.placa} onChange={e => setForm({ ...form, placa: e.target.value })} placeholder="ABC1D23" />
            <Input label="Capacidade de passageiros *" type="number" min="1" max="100" step="1" value={form.capacidade} error={formErrors.capacidade} onChange={e => { setForm({ ...form, capacidade: e.target.value }); if (formErrors.capacidade) setFormErrors(previous => ({ ...previous, capacidade: "" })); }} />
            <p style={{ color: "var(--muted)", fontSize: '0.875rem' }}>Limite de passageiros nesta van. O planejamento usa este número para evitar lotação acima da capacidade.</p>
            </FormSection>
            {submitError && <p role="alert" style={{ color: "var(--danger)", fontSize: '0.9375rem', lineHeight: 1.5 }}>{submitError}</p>}
            <div className="rf-form-actions">
              <FormCancel disabled={loading} />
              <Btn type="submit" disabled={loading} >
                {loading ? <><Spinner /> Salvando...</> : "Salvar veículo"}
              </Btn>
            </div>
          </Form>
        </Modal>
      )}

      <ConfirmModal
        open={Boolean(confirmId)}
        title="Excluir veículo"
        message="Tem certeza? Esta ação não pode ser desfeita."
        confirmLabel="Excluir"
        confirmVariant="danger"
        onClose={() => setConfirmId(null)}
        onConfirm={remove}
      />



      {toast && !(modal && submitError) && (
        <Toast onDismiss={dismissToast} tone={toastType === "error" ? "error" : "success"}>{toast}</Toast>
      )}

    </div>
  );
}

VeiculosPage.propTypes = {
  veiculos: PropTypes.array.isRequired, setVeiculos: PropTypes.func.isRequired, userRole: PropTypes.string,
};
